// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"82bf81db","164":"93cb08c5","254":"55a04549","301":"146f05d4","444":"c87410a3","453":"11e6cbd9","721":"ab9b424c"}[chunkId] + ".chunk.js";
};